export enum CampaignStatus {
  Draft = "draft",
  Active = "active",
  Stopped = "stopped",
  Archived = "archived",
}

export enum ScriptType {
  Phone = "phone",
  PhoneBlaster = "phoneBlaster",
  Email = "email",
  EmailBlaster = "emailBlaster",
  Text = "text",
  TextBlaster = "textBlaster",
}

export enum CampaignLeadStatus {
  Draft = "draft",
  Failed = "failed",
  NoAnswer = "no-answer",
  TooShort = "too-short",
  Answered = "answered",
  Busy = "busy",
  VoiceMail = "voicemail",
}
